<template>
    <div>
      <h3>
        Downloads
      </h3>
      <v-card class="mt-5"
              no-gutters>
        <v-card-text>
          <v-list dense>
            <v-list-item-group
                color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title @click="showIncidentDateDialog=true">Medical Consent/Legal Concent Document
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
  
      <v-dialog v-model="showIncidentDateDialog"
                max-width="350px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Select the incident date:</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="consentDownloadForm" v-model="isValid">
              <v-container>
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                    v-model="menu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        label="From"
                        prepend-icon="mdi-calendar-month"
                        readonly
                        v-bind="attrs"
                        v-model="incidentDate"
                        :rules="[requiredRule]"
                        v-on="on"
                        clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      @input="menu = false"
                      color="secondary"
                      v-model="incidentDate"
                  ></v-date-picker>
                </v-menu>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1"
                   text
                   @click="downloadConsentDoc">
              Download Form
            </v-btn>
  
            <v-btn text
                   @click="showIncidentDateDialog = false">
              Close
            </v-btn>
  
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-snackbar :color="notifyColor"
                  :timeout="15000"
                  top
                  v-model="notifyShow"
      >
        {{ notifyMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn @click="notifyShow = false"
                 class="text-none"
                 icon
                 v-bind="attrs">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  
  </template>
  
  <script>
  import fileDownload from "js-file-download";
  
  export default {
    name: "DependantsDownloadsCard",
    props: ['dependantId', 'identificationNumber'],
    data() {
      return {
        isLoading: false,
        incidentDate: null,
        showIncidentDateDialog: false,
        menu: false,
        notifyShow: null,
        notifyMessage: null,
        notifyColor: null,
        isValid: false,
        requiredRule: (v) => !!v || "required"
      }
    },
    methods: {
      notify(message, color) {
        this.notifyShow = true;
        this.notifyMessage = message;
        this.notifyColor = color;
      },
      downloadConsentDoc() {
        if (this.$refs.consentDownloadForm.validate()) {
          var that = this;
          this.isLoading = true;
  
          this.$store
              .dispatch("customerDependants/downloadDependantMedicalLegalConsentDocument", {
                dependantId: this.dependantId,
                incidentDate: this.incidentDate,
              })
              .then(function (response) {
                console.log(response);
                that.showIncidentDateDialog = false;
                fileDownload(response.data, `${that.identificationNumber}_consentform.pdf`);
                that.notify("Medical Consent/Legal Consent document downloaded.", "success");
              });
        }
      },
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  